import ImpactCard from "./ImpactCard";
import { AiFillSafetyCertificate } from "react-icons/ai";
import { RiTempColdLine } from "react-icons/ri";
import { PiWarehouseFill } from "react-icons/pi";
import { FaTruck } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

function ImpactCards() {
  const { t } = useTranslation();

  const cards = [
    {
      icon: <PiWarehouseFill />,
      title: t('impactCard1'),
    },
    {
      icon: <RiTempColdLine />,
      title: t('impactCard2'),
    },
    {
      icon: <FaTruck />,
      title: t('impactCard3'),
    },
    {
      icon: <AiFillSafetyCertificate />,
      title: t('impactCard4'),
    },
  ];

  return (
    <div className="row g-4">
      {cards.map((card, idx) => (
        <div key={idx} className="col-sm-6">
          <ImpactCard {...card} />
        </div>
      ))}
    </div>
  );
}

export default ImpactCards;
